import { createReducer } from '@reduxjs/toolkit';
import type { SavedSearch, SearchParameters } from 'lib-search-types';
import type { DeepWritable, MarkRequired } from 'ts-essentials';

import {
  initialFilters,
  emptyFilters,
} from './components/filters/utils/definitions';
import { searchActions } from './search.actions';

type SearchState = {
  params: MarkRequired<SearchParameters<'conversations'>, 'filters'>;
  savedSearch?: SavedSearch;
};

export const initialState: SearchState = {
  params: {
    scope: 'conversations',
    query: '',
    filters: initialFilters,
    sortBy: undefined,
    isStrict: false,
    page: 1,
  },
};

export const searchReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(searchActions.params.update, (state, action) => {
      Object.assign(state.params, {
        ...action.payload,
        filters: Object.assign(state.params.filters, action.payload.filters),
        page: action.payload.page ?? 1,
      });
    })

    .addCase(searchActions.savedSearch.apply, (state, action) => {
      state.savedSearch = action.payload as DeepWritable<typeof action.payload>;

      Object.assign(state.params, {
        ...action.payload.searchRequest,
        page: 1,
      });
    })
    .addCase(searchActions.savedSearch.close, (state) => {
      state.params = {
        ...initialState.params,
        filters: emptyFilters,
        scope: state.params.scope,
      } as DeepWritable<typeof state.params>;

      delete state.savedSearch;
    })
    .addCase(searchActions.savedSearch.unset, (state) => {
      delete state.savedSearch;
    }),
);
